import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home/home.component';

import {MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import { ReactiveFormsModule } from '@angular/forms';

// routing
import { CoreRoutingModule } from './core-routing.module';
import { SharedModule } from '../shared/shared.module';
import { OrderListComponent } from './order-list/order-list.component';
import { ProductListComponent } from './product-list/product-list.component';
import { SubscriptionListComponent } from './subscription-list/subscription-list.component';
import { CustomerListComponent } from './customer-list/customer-list.component';
import { SettingsComponent } from './settings/settings.component';
import { AddProductComponent } from './add-product/add-product.component';
import { CategoryListComponent } from './category-list/category-list.component';
import { AddCategoryComponent } from './add-category/add-category.component';


import { NgxSpinnerModule } from "ngx-spinner";
import { ProductDetailComponent } from './product-detail/product-detail.component';
import { EditProductComponent } from './edit-product/edit-product.component';
import { EditOrderComponent } from './edit-order/edit-order.component';


@NgModule({
  declarations: [
    HomeComponent, 
    OrderListComponent, 
    ProductListComponent, 
    SubscriptionListComponent, 
    CustomerListComponent, 
    SettingsComponent, 
    AddProductComponent, 
    ProductDetailComponent,
    CategoryListComponent,
    AddCategoryComponent,
    EditProductComponent,
    EditOrderComponent

  ],
  imports: [
    CommonModule,
    CoreRoutingModule,
    SharedModule,
    MatDialogModule,
    ReactiveFormsModule,
    NgxSpinnerModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [ {provide: MatDialogRef, useValue: []
  }],
})
export class CoreModule { }
